import { PassengerInformationInputModal } from '@common/interfaces/mybooking/modals/passenger-information-input/passenger-Information-input-modal.interface';

// エラーフルネーム情報のエラーキー
export const VALIDATE_FULL_NAME = 'validate-full-name';
// エラーパスポート情報のエラーキー
export const VALIDATE_PASSPORT_NUMBER_REQUIRED = 'validate-passport-number-required';
// エラー発行国情報のエラーキー
export const VALIDATE_ISSUING_COUNTRY_REQUIRED = 'validate-issuing-country-required';

export const VALIDATE_CHINA_NUMBER = 'validate-china-number';

export const VALIDATE_VISA_NUMBER = 'validate-visa-number';

export const VALIDATE_VISA_NUMBER_ALPHA_NUMBER = 'validate-visa-number-alpha-number';

export const VALIDATE_VISA_NUMBER_LENGTH = 'validate-visa-number-length';

export const VALIDATE_US_VISA_NUMBER_LENGTH = 'validate-us-visa-number-length';

export const VALIDATE_IMMIGRATION_DATE_REQUIRED = 'validate-immigration-date-required';

export const TravelerSupportBatteryType = {
  NICKEL_CADMIUM: 'nickelCadmium', // ニッカド
  NICKEL_METAL_HYDRIDE: 'nickelMetalHydride', // ニッケル水素
  LITHIUM_ION: 'lithiumIon', // リチウムイオン
  SHIELD_BATTERY: 'shieldBattery', // シールド(カート取得APIから返却される形)
  NON_SHIELD_BATTERY: 'nonShieldBattery', // ノンシールド(カート取得APIから返却される形)
};

export const TravelerSupportBatteryTypeUpdateTravelers = {
  NICKEL_CADMIUM: 'nickelCadmium',
  NICKEL_METAL_HYDRIDE: 'nickelMetalHydride',
  LITHIUM_ION: 'lithiumIon',
  SHIELD_BATTERY: 'nonSpillableBattery',
  NON_SHIELD_BATTERY: 'spillableBattery',
};

export type PassengerInformationInputModalEditArea =
  (typeof PassengerInformationInputModalEditArea)[keyof typeof PassengerInformationInputModalEditArea];
export const PassengerInformationInputModalEditArea = {
  REPRESENTATIVE_CONTACT: 'representativeContact',
  UPGRADE_NOTIFICATION: 'upgradeNotification',
  TRAVELER_INPUT: 'travelerInput',
  DESTINATION_ADDRESS: 'destinationAddress',
};

export const PhoneDestinationType = {
  REPRESENTATIVE: '0',
  INDIVIDUAL: '1',
  NOT_SEND: '2',
};

export const MailDestinationType = {
  REPRESENTATIVE: '0',
  INDIVIDUAL: '1',
  NOT_SEND: '2',
};

export const SecondContactDestinationType = {
  SAME_PASSENGER_1: '0',
  INDIVIDUAL: '1',
  REGISTER_LATER: '2',
};

export const RegistrationLabelType = {
  REGISTERED: 'label.registered1',
  NOT_REGISTERED: 'label.notRegistered',
  EDITING: 'label.editing',
};

export const INITIAL_PASSENGER_INFO_INPUT_MODAL_STATE: PassengerInformationInputModal = {
  isEditing: false,
  editArea: '',
  travelerId: '',
};

/**
 * 会員種別
 * @param MALE 男性
 * @param FEMALE 女性
 * @param UNKNOWN 不明
 * @param UNKNOWN 不明
 * @param NOT_SPECIFIED
 */
export type GenderCodeType = (typeof GenderCodeType)[keyof typeof GenderCodeType];
export const GenderCodeType = {
  MALE: 'male',
  FEMALE: 'female',
  UNKNOWN: 'unknown',
  NOT_SPECIFIED: 'unspecified',
};

export type ImmigrationSecondDocumentTypeEnum = 'VISA' | 'GREEN_CARD' | 'NOTHING';
export const ImmigrationSecondDocumentType = {
  NOTHING: 'NOTHING' as ImmigrationSecondDocumentTypeEnum,
  VISA: 'VISA' as ImmigrationSecondDocumentTypeEnum,
  GREEN_CARD: 'GREEN_CARD' as ImmigrationSecondDocumentTypeEnum,
};

export type ImmigrationStayTypeEnum = 'transit' | 'stayInUS';
export const ImmigrationStayType = {
  TRANSIT: 'transit' as ImmigrationStayTypeEnum,
  STAY_IN_US: 'stayInUS' as ImmigrationStayTypeEnum,
};

export type SpecialAssistanceRequestType =
  (typeof SpecialAssistanceRequestType)[keyof typeof SpecialAssistanceRequestType];
export const SpecialAssistanceRequestType = {
  SPECIAL_ASSISTANCE: 'specialAssistance',
  WALKING_ABILITY: 'walkingAbility',
  WHEELCHAIRS: 'wheelchairs',
  FOLDING_TYPE: 'foldingType',
  WHEELCHAIR_TYPE: 'wheelchairType',
  PREGNANT: 'pregnant',
  UNKNOWN: '',
} as const;

export const WHEEL_CHAIR_MANUAL_CODE = 'manual';

export const WHEEL_CHAIR_BATTERY_CODE = 'battery';

export const PHONE_EXTENSION_JP = '81';

export const BLIND = 'BLND';

export const DEAF = 'DEAF';

export const YYYY_MM_DD = 'yyyy-MM-dd';

export const SmsChangeWarningMessage = {
  contentHtml: 'MSG1047',
  contentId: 'MSG1047',
  isCloseEnable: true,
};

export const SmsChangeWarningMessageOnPhoneNumberChange = {
  contentHtml: 'MSG1659',
  contentId: 'MSG1659',
  isCloseEnable: true,
};

export const ANA_NAME_CODE = 'NH';

export const LOAD_MASTER_SUBSCRIPTION = 'S04-M010 loading master data subscription';
export const AFTER_MASTER_LOADED_SUBSCRIPTION = 'S04-M010 after master data loaded subscription';

export const DEFAULT_IMMIGRATION_EXPIRY_DATE: string = '1999-12-31';
